import {
  DEFAULT_INVOICE_SEQUENTIAL_START,
  INVOICE_NUMBERING_MODES,
  type InvoiceNumberingMode,
  type InvoiceNumberingState,
} from "../types/invoiceNumbering.types";

export const isInvoiceNumberingMode = (value: unknown): value is InvoiceNumberingMode =>
  value === INVOICE_NUMBERING_MODES.TIMESTAMPED || value === INVOICE_NUMBERING_MODES.SEQUENTIAL;

export const normalizeInvoiceNumberingState = (company: any): InvoiceNumberingState => {
  const mode = isInvoiceNumberingMode(company?.invoiceNumberingMode) ? company.invoiceNumberingMode : INVOICE_NUMBERING_MODES.TIMESTAMPED;

  const parsedNext = Number(company?.invoiceNextNumber);
  const invoiceNextNumber = Number.isInteger(parsedNext) && parsedNext >= 1 ? parsedNext : null;

  return {
    invoiceNumberingMode: mode,
    invoiceNextNumber: mode === INVOICE_NUMBERING_MODES.SEQUENTIAL ? (invoiceNextNumber ?? DEFAULT_INVOICE_SEQUENTIAL_START) : invoiceNextNumber,
  };
};

export const parseInvoiceStartNumber = (value: string): number | null => {
  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) return null;

  const parsed = Number(trimmed);
  if (!Number.isInteger(parsed) || parsed < 1) return null;

  return parsed;
};
